import { toast } from "sonner";
import { Share2 } from "lucide-react";

export const ArticleShare = ({ title, text, testId, label = "Share with a friend" }) => {
  const share = async () => {
    const url = window.location.href.split("#")[0];
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
      } catch (e) {
        if (e.name !== "AbortError") toast.error("Couldn't open sharing");
      }
      return;
    }
    navigator.clipboard.writeText(url).then(() => toast.success("Link copied. Paste it to a friend"), () => toast.error("Couldn't copy the link"));
  };
  return (
    <button data-testid={testId} onClick={share}
      className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1C1917] text-white text-sm font-medium hover:bg-[#E06D44] active:scale-95 transition-[background-color,transform]">
      <Share2 size={16} /> {label}
    </button>
  );
};
